import { useCurrentUser, useIsMobile } from '@agro1desenvolvimento/react-hooks';
import { loginService } from '@agro1desenvolvimento/apis-js-package';
import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useRef, useEffect } from 'react';
import { Dropdown } from '@agro1desenvolvimento/react-components';
import { toggleActive } from '../Sidebar/sidebarSlice';
import { removeProjectItens } from '../../utilities/local-storage';
import {
  selectTopBarState,
  setCurrentProdutor,
  fetchProdutoresLaboratorio,
} from '../Topbar/topBarSlice';
import './Header.scss';

export interface BreadcrumbItem {
  label: string;
  url?: string;
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  breadcrumbs?: BreadcrumbItem[];
  lockProdutor?: boolean;
}

export default function Header({ children, lockProdutor = false, ...props }: Props) {
  const currentUser = useCurrentUser();
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { produtores, currentProdutor } = useSelector(selectTopBarState);

  const handleToggleSidebar = () => {
    dispatch(toggleActive());
  };

  const logout = () => {
    loginService.logout();
    removeProjectItens();
  };

  const selectApps = () => {
    loginService.redirectToScopeSelection();
    removeProjectItens();
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const fetchProdutorByParams = (query = '') => {
    dispatch(fetchProdutoresLaboratorio({
      nome: query,
    }));
  };

  useEffect(() => {
    if (loginService.scope) {
      dispatch(fetchProdutoresLaboratorio());
    }
  }, [dispatch]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <div className="header" {...props}>
      <div className="header__left">
        {isMobile && (
          <button
            type="button"
            className="header__mobile-toggle"
            onClick={handleToggleSidebar}
          >
            <i className="pi pi-bars" />
          </button>
        )}
        {children ?? <span />}
      </div>
      <div className="header__user-info" ref={dropdownRef}>
        <span className="header__produtor-dropdown">
          <Dropdown
            id="selectProdutor"
            value={currentProdutor?.id}
            onChange={(event) => dispatch(setCurrentProdutor(event.value))}
            options={produtores}
            optionValue="id"
            optionLabel="nomeComCidade"
            filter
            filterBy="nome"
            onFilter={(e) => {
              fetchProdutorByParams(e.filter);
            }}
            placeholder="Produtor"
            required
            appendTo={document.body}
            disabled={lockProdutor}
          />
        </span>
        <div className="header__user-info__user">
          <span className="header__user-info__name">
            {currentUser?.name}
          </span>
          <div className="header__user-dropdown">
            <button
              type="button"
              className="header__user-dropdown__trigger"
              onClick={toggleDropdown}
            >
              <img
                src={currentUser?.avatar}
                alt="Profile"
                className="header__user-info__avatar"
              />
            </button>

            {dropdownOpen && (
              <div className="header__user-dropdown__menu">
                <button
                  type="button"
                  className="header__user-dropdown__item"
                  onClick={selectApps}
                >
                  <i className="pi pi-th-large" />
                  <span>Selecionar Apps</span>
                </button>
                <button
                  type="button"
                  className="header__user-dropdown__item header__user-dropdown__item--logout"
                  onClick={logout}
                >
                  <i className="pi pi-sign-out" />
                  <span>Sair</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
